import moment from 'moment'
import React from 'react'

// Styles
import {
  SecodaryBlogHeroWrapper,
  SecondaryHeroImageWrapper,
  TopBlogOuter,
  TopBlogSection,
} from './style'

// Utils
import { generateAdData } from '../../../../utils/functions.utils'
import ImgUtil from '../../../../utils/img.utils'

// Components
import Grid from '@material-ui/core/Grid'
import { UseCaseTypes } from '../../../../constants/blogUseCase'
import { OPTIONS } from '../../../../constants/dateOptions'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { generateBlogPostSlug, generateSecondaryBlogSlug } from '../../../../utils/blog.utils'
import BlogListing from '../../../global/blogListing'
import Button from '../../../global/button'
import GlobalContainer from '../../../global/globalContainer'
import Typography from '../../../global/typography'
import WrapperImage from '../../../global/wrapperImage'
import Layout from '../../../layouts/layout'
import BlogNavigation from '../navigation'

const MainBlogLanding = ({
  path,
  pageContext,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}: any) => {
  let primaryPost: any
  const homePageData = pageContext.homePageData
  const useCase = homePageData?.useCase || null
  const listingTitle = homePageData?.listingTitle || ''
  const isMainBlog = useCase === UseCaseTypes.MAIN_BLOG
  const pageNumber =
    pageContext && pageContext.pageData && pageContext.pageData.pageNumber
      ? pageContext.pageData.pageNumber
      : null
  const featuredResource =
    pageContext && pageContext.blogFeaturedResource ? pageContext.blogFeaturedResource : null

  const subscribe =
    pageContext && pageContext.pageData && pageContext.pageData.subscribe && isMainBlog
      ? pageContext.pageData.subscribe
      : null

  let defaultLocale = LocaleCodes.ENGLISH.code

  if (pageContext && pageContext.pageLocale) {
    defaultLocale = pageContext.pageLocale
  }

  const fillInBlogFields = (post: any, useCase: string) => {
    let blogItem = {
      postImageSrc: '',
      postImageAlt: '',
      postArticleDate: '',
      postArticleTitle: '',
      postArticleSubtitle: '',
      postArticleCategory: '',
      postLink: '',
    }
    const isMainBlog = useCase === UseCaseTypes.MAIN_BLOG
    if (post.blogCategory && post.blogCategory.title) {
      blogItem.postArticleCategory = post.blogCategory.title
      if (post.blogCategory.title === 'Robotic Process Automation (RPA)') {
        blogItem.postArticleCategory = 'RPA'
      } else if (post.blogCategory.title === 'Artificial Intelligence (AI)') {
        blogItem.postArticleCategory = 'AI'
      }
    }

    if (post.mainImage) {
      if (post.mainImage.altText) {
        blogItem.postImageAlt = post.mainImage.altText
      }
      if (post.mainImage.image && post.mainImage.image.file && post.mainImage.image.file.url) {
        blogItem.postImageSrc = post.mainImage.image.file.url
      }
    }
    const blogDate = post.date ? new Date(post.date) : ''

    if (blogDate) {
      blogItem.postArticleDate = moment(blogDate).format('MMMM DD, YYYY') // 9 Jul 2020
    }
    if (post.h1Title) {
      blogItem.postArticleTitle = post.h1Title
    }
    if (post.teaserBody && post.teaserBody.raw) {
      blogItem.postArticleSubtitle = post.teaserBody.raw
    } else if (post.seo && post.seo.pageMetaDescription) {
      blogItem.postArticleSubtitle = post.seo.pageMetaDescription
    }

    if (post.slug) {
      if (post.blogCategory && post.blogCategory.title) {
        let categoryId = post.blogCategory.title
        if (post.blogCategory.overwriteUrlText) categoryId = post.blogCategory.overwriteUrlText
        let blogCategoryPath = categoryId
          .toLowerCase()
          .replace(/ *\([^)]*\) */g, '')
          .replace(/\s/g, '-')
        if (blogCategoryPath) {
          if (blogCategoryPath === 'artificial-intelligence') {
            blogCategoryPath = 'ai'
          } else if (blogCategoryPath === 'robotic-process-automation') {
            blogCategoryPath = 'rpa'
          }
        }
        if (!isMainBlog) {
          blogItem.postLink = generateSecondaryBlogSlug({
            slug: post.slug,
            blogCategoryName: blogCategoryPath,
            useCase,
            pageLocale: defaultLocale,
          })
        } else {
          blogItem.postLink = generateBlogPostSlug({
            slug: post.slug,
            blogCategoryName: blogCategoryPath,
            pageLocale: defaultLocale,
          })
        }
      }
    }
    return blogItem
  }

  if (pageContext && pageContext.primaryPost && pageContext.primaryPost.node) {
    primaryPost = fillInBlogFields(pageContext.primaryPost.node, useCase)
  }

  let secondaryPosts: any = []
  if (pageContext && pageContext.secondaryPosts && pageContext.secondaryPosts.length !== 0) {
    secondaryPosts = pageContext.secondaryPosts
  }
  let totalBlogsToPaginate = pageContext?.pageData?.totalPages || 0

  if (primaryPost) {
    totalBlogsToPaginate -= 1
  }
  if (secondaryPosts) {
    totalBlogsToPaginate -= secondaryPosts.length
  }

  const getFeaturedAd = () => {
    if (featuredResource) {
      return generateAdData(featuredResource)
    }
  }

  const generateSecondaryArticles = () => {
    if (pageContext && pageContext.secondaryPosts && pageContext.secondaryPosts.length !== 0) {
      return pageContext.secondaryPosts.map((post: any, n: number) => {
        const secondaryPost = fillInBlogFields(post.node, useCase)
        let convertedDate
        if (secondaryPost.postArticleDate) {
          convertedDate = new Date(secondaryPost.postArticleDate).toLocaleDateString(
            defaultLocale,
            OPTIONS
          )
        }
        return (
          <a
            href={secondaryPost.postLink}
            className="TopBlog__Secondary-Article"
            title={secondaryPost.postArticleTitle}
            key={`secondaryPost--${n}`}>
            <div className="TopBlog__Secondary-Article-Img-Container">
              {secondaryPost && secondaryPost.postImageSrc && (
                <WrapperImage
                  className="TopBlog__Secondary-Img"
                  src={ImgUtil.getResizedImageUrl(secondaryPost.postImageSrc, '')}
                  alt={secondaryPost.postImageAlt ? secondaryPost.postImageAlt : 'Software Robots'}
                  width={80}
                  height={80}
                  threshold={650}
                />
              )}
            </div>
            <div className="TopBlog__Secondary-Article-Txt-Container">
              <div className="TopBlog__Secondary-Article-Txt-Category-Date">
                {secondaryPost && secondaryPost.postArticleCategory && (
                  <Typography className="TopBlog__Secondary-Article-Category" type="captionAlt">
                    {secondaryPost.postArticleCategory}
                  </Typography>
                )}
                {secondaryPost && convertedDate && (
                  <Typography className="TopBlog__Secondary-Article-Date" type="caption">
                    {convertedDate}
                  </Typography>
                )}
              </div>
              {secondaryPost && secondaryPost.postArticleTitle && (
                <Typography className="TopBlog__Secondary-Article-Title" type="header6">
                  {secondaryPost.postArticleTitle}
                </Typography>
              )}
            </div>
          </a>
        )
      })
    }
  }

  const gerenateBlogHero = () => {
    const secondaryPosts = generateSecondaryArticles()
    return isMainBlog ? (
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <a
            href={primaryPost && primaryPost.postLink ? primaryPost.postLink : '/blog'}
            title={
              primaryPost && primaryPost.postArticleTitle
                ? primaryPost.postArticleTitle
                : 'Software robots blog post'
            }
            className="TopBlog__Primary">
            <div className="TopBlog__Primary-Img-Robot">
              <div className="TopBlog__Primary-Img-Container">
                {primaryPost && primaryPost.postImageSrc && (
                  <img
                    className="TopBlog__Primary-Img"
                    src={ImgUtil.getResizedImageUrl(primaryPost.postImageSrc, '')}
                    alt={primaryPost.postImageAlt ? primaryPost.postImageAlt : 'Software Robots'}
                    width={590}
                    height={295}
                  />
                )}
              </div>
              <img
                className="TopBlog__Primary-Robot-Img"
                src={ImgUtil.getResizedImageUrl(
                  'https://images.ctfassets.net/5965pury2lcm/w4dR8WWNxkfLokcZbBvVZ/595b96524f4aa991fe380d7cff62b0de/UiPath-Blog-Robot-Icon.png',
                  ''
                )}
                alt="Software Robots"
                width={178}
                height={153}
              />
            </div>
            <div className="TopBlog__Primary-Article-Txt-Container">
              {primaryPost && primaryPost.postArticleDate && (
                <Typography className="TopBlog__Primary-Article-Date" type="caption">
                  {new Date(primaryPost.postArticleDate).toLocaleDateString(defaultLocale, OPTIONS)}
                </Typography>
              )}
              {primaryPost && primaryPost.postArticleTitle && (
                <Typography className="TopBlog__Primary-Article-Title" type="header1">
                  {primaryPost.postArticleTitle}
                </Typography>
              )}
              {primaryPost && primaryPost.postArticleSubtitle && (
                <Typography className="TopBlog__Primary-Article-Subtitle" type="leadXS">
                  {primaryPost.postArticleSubtitle}
                </Typography>
              )}
            </div>
          </a>
        </Grid>
        <Grid item xs={12} md={4} lg={4}>
          <div className="TopBlog__Secondary">
            {generateSecondaryArticles()}
            {subscribe && (
              <a
                href="/"
                className="TopBlog__Secondary-Article SubscribeModal__Trigger"
                title="Subscribe to the blog">
                <div className="TopBlog__Secondary-Article-Img-Container TopBlog__Secondary-Article-Img-Container--Subscribe">
                  <img
                    className="TopBlog__Secondary-Img"
                    src={ImgUtil.getResizedImageUrl(
                      'https://images.ctfassets.net/5965pury2lcm/7tLFktvb9gU5OBoXYGZVCI/505f06436d1e6b9df3bdfd0874311d20/contact-email_alt.png',
                      ''
                    )}
                    alt="Envelope"
                    width={80}
                    height={80}
                  />
                </div>
                <div className="TopBlog__Secondary-Article-Txt-Container">
                  <div className="TopBlog__Secondary-Article-Txt-Category-Date">
                    <Typography className="TopBlog__Secondary-Article-Category" type="captionAlt">
                      {subscribe.featuredCardPill}
                    </Typography>
                  </div>
                  <Typography className="TopBlog__Secondary-Article-Title" type="header6">
                    {subscribe.featuredCardHeadline}
                  </Typography>
                </div>
              </a>
            )}
          </div>
        </Grid>
      </Grid>
    ) : (
      <SecodaryBlogHeroWrapper>
        <Grid container spacing={3}>
          <Grid item xs={12} className="Secondary__Blog__Hero-Img-Container">
            <a
              href={primaryPost && primaryPost.postLink ? primaryPost.postLink : '/blog'}
              title={
                primaryPost && primaryPost.postArticleTitle
                  ? primaryPost.postArticleTitle
                  : 'Software robots blog post'
              }
              className="Secondary__Blog__TopBlog__Primary">
              <div className="Secondary__Blog__TopBlog__Primary-Img-Robot">
                <SecondaryHeroImageWrapper className="TopBlog__Secondary-Img-Container">
                  {primaryPost && primaryPost.postImageSrc && (
                    <img
                      className="TopBlog__Secondary-Img"
                      src={ImgUtil.getResizedImageUrl(primaryPost.postImageSrc, 'width=892')}
                      alt={primaryPost.postImageAlt ? primaryPost.postImageAlt : 'Software Robots'}
                      width={792}
                      height={396}
                    />
                  )}
                </SecondaryHeroImageWrapper>
              </div>
              <div className="SecondaryBlog_Primary-Article-Txt-Container">
                <img
                  className="TopBlog__Secodary-Robot-Img"
                  src={ImgUtil.getResizedImageUrl(
                    'https://images.ctfassets.net/5965pury2lcm/2TA7SYTkjydtpUobhssY8A/b3bfad8a30ff11e513d9c60d803ee261/Right.png',
                    ''
                  )}
                  alt="Software Robots"
                  width={180}
                  height={128}
                />
                {primaryPost && primaryPost.postArticleDate && (
                  <Typography className="TopBlog__Primary-Article-CategoryTitle" type="captionAlt">
                    {primaryPost.postArticleCategory}
                  </Typography>
                )}
                {primaryPost && primaryPost.postArticleTitle && (
                  <Typography className="TopBlog__Primary-Article-Title" type="header3">
                    {primaryPost.postArticleTitle}
                  </Typography>
                )}
                {primaryPost && primaryPost.postArticleSubtitle && (
                  <Typography className="TopBlog__Primary-Article-Subtitle" type="leadXS">
                    {primaryPost.postArticleSubtitle}
                  </Typography>
                )}
                <Button
                  href={primaryPost && primaryPost.postLink ? primaryPost.postLink : '/blog'}
                  icon={true}
                  text={'Read Article'}
                  iconAlignment="left"
                  type="text-link"
                  size="small"
                  theme="light"
                  className="TopBlog__Primary-Article-Button"
                />
              </div>
            </a>
          </Grid>
          <Grid container spacing={3} className="Secondary__Blog__Hero-Bottom-Articles">
            {secondaryPosts &&
              secondaryPosts.length === 3 &&
              secondaryPosts.map((secondaryPost: any, index: number) => {
                return (
                  <Grid
                    xs={12}
                    md={6}
                    lg={4}
                    key={index}
                    item
                    className="Secondary__Blog__Hero-Bottom-Posts">
                    {secondaryPost}
                  </Grid>
                )
              })}
          </Grid>
        </Grid>
      </SecodaryBlogHeroWrapper>
    )
  }

  // disable secondary posts if there are less than 3. merge with main lisitngs
  const mainListing =
    secondaryPosts && secondaryPosts.length < 3
      ? [
          ...secondaryPosts.map((p: any) => p.node),
          ...pageContext.pageData.blogPosts.map((p: any) => p.node),
        ]
      : pageContext.pageData.blogPosts.map((p: any) => p.node)

  return (
    <Layout.Template
      lang={defaultLocale}
      pageType="blog"
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}>
      <div data-cy="MainBlogLanding">
        {pageContext && pageContext.blogNav && (
          <BlogNavigation
            blogNav={pageContext.blogNav}
            pagePath={pageContext?.pageData?.path ? pageContext.pageData.path : '/blog'}
            useCase={useCase}
          />
        )}
        {pageContext && pageContext.pageData && pageContext.pageData.blogPosts && (
          <>
            {pageNumber && pageNumber === 1 && (
              <TopBlogOuter>
                <GlobalContainer>
                  <TopBlogSection>{gerenateBlogHero()}</TopBlogSection>
                </GlobalContainer>
              </TopBlogOuter>
            )}
            <BlogListing
              posts={mainListing}
              totalPages={pageContext.pageData.totalPages}
              pageNumber={pageContext.pageData.pageNumber}
              slug={`${pageContext.homePageData.slug}`}
              subscribe={subscribe}
              seoData={pageContext.homePageData.seoMetadata}
              collectionRowData={isMainBlog ? pageContext.collectionRowData : null}
              numListingPages={pageContext.pageData.totalBlogLandingPages}
              blogFRData={isMainBlog ? getFeaturedAd() : null}
              locale={defaultLocale}
              listingTitle={listingTitle}
              isMainBlog={isMainBlog}
            />
          </>
        )}
      </div>
    </Layout.Template>
  )
}

export default MainBlogLanding
